const DetectType = Object.freeze({
  LOGO: 'Logo',
  OBJECT: 'Object',
  SCENE: 'Scene',
  EMOTION: 'Emotion'
})
export default DetectType
export type DetectTypeStrings = typeof DetectType[keyof typeof DetectType]
// RESERVE BELOW
